import { CircularProgress, IconButton, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useEffect } from "react";
import { useAlert } from "react-alert";
import {
  RequestForHelpStatus,
  useRequestForHelpClient,
} from "./requestForHelpClient";
import { Status } from "../client/status";
import { HandPaperIcon } from "../design-system/Icons";

export function AskForHost() {
  const { status, sendRequest } = useRequestForHelpClient();
  const alert = useAlert();

  useEffect(() => {
    switch (status) {
      case Status.Success:
      case RequestForHelpStatus.Conflict: {
        alert.success("Someone will be there with you shortly.");
        break;
      }
      case Status.Error: {
        alert.error("Sorry something went wrong!");
        break;
      }
    }
  }, [alert, status]);

  const isPending = status === Status.Pending;
  const isNotified =
    status === Status.Success || status === RequestForHelpStatus.Conflict;

  return (
    <IconButton
      onClick={sendRequest}
      disabled={isPending || isNotified}
      aria-label="ask-host-button"
      role="button"
      size="large"
      data-testid="test-id-ask-for-host-button"
      sx={{
        display: "flex",
        flexDirection: "column",
        "&.Mui-disabled": {
          color: isNotified ? "#a5d6a7" : "rgba(255,255,255,0.38)",
        },
        color: "white",
      }}
    >
      {isPending ? (
        <CircularProgress size={28} sx={{ color: "white" }} />
      ) : isNotified ? (
        <CheckCircle fontSize="large" />
      ) : (
        <HandPaperIcon />
      )}
      <Typography variant="caption">
        {isNotified ? "Notified ✓" : "Ask Host"}
      </Typography>
    </IconButton>
  );
}
